// Dependencies
import { FC, ReactNode, useState } from "react";

// Components
import { Typography } from "@mui/material";

// Styles
import {
  StyledIcon,
  StyledItem,
  StyledLabel,
  StyledDropDown,
  StyledIconChild,
  StyledLabelChild,
} from "./CategoryItem.styled";

interface CategoryItemProps {
  id: string;
  icon: string;
  label: string;
  child?: boolean;
  children?: ReactNode;
  onSelect: Function;
}

const CategoryItem: FC<CategoryItemProps> = ({
  id,
  icon,
  label,
  child,
  children,
  onSelect,
}) => {
  //States
  const [parentSelected, setParentSelected] = useState<number>(0);

  // methods
  const handleSelectItem = () => {
    /**If parent item, count the click to 2nd */
    if (children) {
      setParentSelected((prev) => prev + 1);
    } else {
      onSelect(id, label);
    }
    if (parentSelected === 1) {
      onSelect(id, label);
    }
  };

  const ItemLabel = ({ icon, label }: { icon: string; label: string }) => {
    if (child) {
      return (
        <StyledLabelChild>
          <StyledIconChild src={icon} />
          <Typography variant={"h4"}>{label}</Typography>
        </StyledLabelChild>
      );
    }
    return (
      <StyledLabel>
        {children && <StyledDropDown />}
        <StyledIcon src={icon} />
        <Typography variant={"h3"}>{label}</Typography>
      </StyledLabel>
    );
  };
  return (
    <StyledItem
      onClick={handleSelectItem}
      nodeId={id}
      label={<ItemLabel icon={icon} label={label} />}
    >
      {children}
    </StyledItem>
  );
};

export default CategoryItem;
